<template>
	<div>
		<div class="arp-botoes-listagem-itens-ata mb-6">
			<div v-if="hasItens && temPermissaoEdicao && !aditivoApostila.isEfetivado" class="flex-column flex-sm-row d-flex justify-sm-start">
				<menu-acoes
					class="botao-tamanho-arp mr-2"
					:nome-botao="menuAcoesItens.nome"
					:nome="menuAcoesItens.nome"
					cor-icone="--v-error-base"
					icone-primary="add_circle"
					icone-secondary="arrow_drop_down"
					:acoes-menu="menuAcoesItens.itens"
					tamanho-icone-primary="0.9rem"
					tamanho-icone-secondary="0.9rem"
					tamanho-icone-menu="18px"
					@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
					@adicionar-anexo="abrirOuFecharModalNovoAnexo"
					:disabled="!hasItens && !temPermissaoEdicao"
				>
				</menu-acoes>
				<menu-acoes
					v-if="isProcessoDigitalAtivo"
					class="botao-tamanho-arp"
					:nome-botao="menuAcoesEmMassa.nome"
					:nome="menuAcoesEmMassa.nome"
					cor-icone="--v-error-base"
					icone-secondary="arrow_drop_down"
					:outlined="true"
					:key="atualizarListagem"
					block
					corDeFundo="grey"
					:acoes-menu="menuAcoesEmMassa.itens"
					tamanho-icone-menu="18px"
					@assinar-documentos="abrirOuFecharModalAssinaturaEletronicaEmLote"
					@juntar-documentos="abrirModalJuntar"
					:disabled="!hasItens && !temPermissaoEdicao && aditivoApostila.isEfetivado"
				>
				</menu-acoes>
			</div>
		</div>

		<div>
			<segunda-etapa-aditivo-apostila-listagem
				:key="atualizarListagem"
				:itens="documentos"
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:paginacao="paginacao"
				:ata="infoAta"
				@paginar="setPaginacaoListagem"
				@resetar-page="resetarPaginaListagem"
				@recarregar-listagem-externa="buscarDocumentos"
				@continuar-elaboracao-termo-desentranhamento="tratarEventoContinuarElaboracaoTermoDesentranhamento"
				@criar-termo-desentranhamento="tratarEventoCriarTermoDesentranhamento"
				@convidar-signatarios="tratarEventoConvidarSignatarios"
				@visualizar-signatarios="tratarEventoVisualizarSignatarios"
			></segunda-etapa-aditivo-apostila-listagem>
			<az-container class="listagem">
				<template-listagem-vazia
					:textos="textosTemplateListagemVazia"
					:total-itens="totalItens"
					@botao-evento="abrirOuFecharModalAdicionarDocumento"
				>
					<template #acoes>
						<menu-acoes
							v-if="temPermissaoEdicao && !aditivoApostila.isEfetivado"
							class="acessar-ata-itens-btn-mais-acoes"
							:nome-botao="menuAcoesItens.nome"
							:nome="menuAcoesItens.nome"
							cor-icone="--v-error-base"
							icone-primary="add_circle"
							icone-secondary="arrow_drop_down"
							:acoes-menu="menuAcoesItens.itens"
							tamanho-icone-primary="0.9rem"
							tamanho-icone-secondary="0.9rem"
							tamanho-icone-menu="18px"
							@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
							@adicionar-anexo="abrirOuFecharModalNovoAnexo"
						>
						</menu-acoes>
					</template>
				</template-listagem-vazia>
			</az-container>
		</div>

		<div v-if="temPermissaoEdicao && !aditivoApostila.isEfetivado">
			<modal-novo-documento
				id="modal-adicionar-documento"
				:idDocPai="Number(idAta)"
				:exibir="exibirModalAdicionarDocumento"
				:tipo-documento="tipoModeloDocumento"
				@salvar-documento="salvarDocumento"
				@fechar-modal="abrirOuFecharModalAdicionarDocumento"
			>
			</modal-novo-documento>

			<modal-novo-anexo
				id="modal-novo-anexo"
				:exibir="exibirModalAdicionarAnexo"
				:infoAnexo="infoAta"
				:tipo-documento="[]"
				@salvar-anexo="salvarAnexo"
				@fechar-modal="abrirOuFecharModalNovoAnexo"
			>
			</modal-novo-anexo>

			<modal-assinatura-signatario
				v-if="exibirModalSignatarios"
				:signatarios="signatarios"
				:exibir="exibirModalSignatarios"
				:titulo="tituloModal"
				@fechar-modal="fecharModalSignatarios"
			></modal-assinatura-signatario>

			<modal-selecao-tipo-assinatura
				:permissao-assinatura-eletronica="permissoes.ataAssinaturaEletronicaCriar"
				:permissao-assinatura-digital="permissoes.ataAssinaturaDigitalCriar"
				@assinar-eletronicamente="realizarAssinaturaEletronicaIndividual"
				@assinar-digitalmente="realizarAssinaturaDigital"
			></modal-selecao-tipo-assinatura>

			<modal-assinatura-eletronica
				v-if="exibirModalAssinaturaEmLote"
				titulo="Assinar Eletronicamente em massa"
				nome-botao-confirmar="Assinar"
				:exibir="exibirModalAssinaturaEmLote"
				@fechar-modal="abrirOuFecharModalAssinaturaEletronicaEmLote"
				@assinar-eletronicamente="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-eletronica>

			<modal-assinatura-progresso-lote
				v-if="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:exibir="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:documentos="assinaturasDocumentosNaoConcluidas"
				@atualizar="atualizarModalAssinaturasNaoConcluidas"
				@fechar-modal="fecharModalNotificacaoAssinaturaEletronicaEmLote"
				@assinar-individualmente-documento="realizarAssinaturaEletronicaIndividual"
				@assinar-eletronicamente-documento-lote="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-progresso-lote>

			<formulario-assinatura-convite
				v-if="exibirModalConvidarSignatarios"
				:exibir-modal="exibirModalConvidarSignatarios"
				:titulo-modal="tituloModal"
				:titulo-documento="tituloDocumento"
				:id-associacao="idAssociacao"
				@fechar-modal="fecharModal"
				@confirmar-signatarios="convidarSignatarios"
				@excluir-signatario="tratarEventoExcluirSignatario"
				:func-buscar="buscarSignatarios"
			></formulario-assinatura-convite>

			<modal-confirmacao
				:titulo-modal="tituloModal"
				:mensagem="mensagemConfirmacaoModal"
				:subtitulo-modal="subtituloConfirmacaoModal"
				:exibir="exibirModalConfirmacao"
				@confirmar="confirmarAcaoModal"
				@fechar-modal="fecharAcaoModal"
			>
			</modal-confirmacao>
			<modal-informativo
				:mensagem-modal="mensagemInformativoModal"
				:exibir-modal="exibirModalInformativo"
				@confirmar-acao-informativo="fecharModalInformativo"
			></modal-informativo>
		</div>
	</div>
</template>
<script>
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes, getterTypes, permissoes, routesNames, situacoes, tipoModeloDocumento } from '@/core/constants'
import mutationTypes from '@/core/constants/mutation-types'
import AssinarEletronicamenteDocAtaLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocAtaLoteInput'
import { mapGetters, mapState } from 'vuex'
import assinatura from '@/views/mixins/assinatura'
import validacaoAta from '@/views/mixins/validacaoAta'
import documentoMixin from '@/views/mixins/documento'
import convidarSignatarios from '@/views/mixins/signatarios/convidar-signatarios'
import ModalSelecaoTipoAssinatura from '@/views/components/assinatura/selecao-tipo/ModalSelecaoTipoAssinatura.vue'
import ModalAssinaturaProgressoLote from '@/views/components/assinatura/progresso-lote/ModalAssinaturaProgressoLote.vue'
import ModalNovoDocumento from '@/views/components/documentos/novo-documento/ModalNovoDocumento.vue'
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica.vue'
import ModalNovoAnexo from '@/views/components/documentos/novo-anexo/ModalNovoAnexo.vue'
import FormularioAssinaturaConvite from '@/views/components/documentos/signatario/convite/FormularioAssinaturaConvite.vue'
import ModalAssinaturaSignatario from '@/views/components/documentos/signatario/visualizar/ModalAssinaturaSignatario.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import MenuAcoes from '@/views/components/MenuAcoes.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import ModalInformativo from '@/views/components/ModalInformativo.vue'
import SegundaEtapaAditivoApostilaListagem from '@/views/pages/ata/acessar/aditivo-apostila/segunda-etapa/listagem/SegundaEtapaAditivoApostilaListagem.vue'

export default {
	name: 'segunda-etapa-aditivo-apostila',
	components: {
		SegundaEtapaAditivoApostilaListagem,
		ModalInformativo,
		ModalConfirmacao,
		MenuAcoes,
		TemplateListagemVazia,
		ModalAssinaturaSignatario,
		FormularioAssinaturaConvite,
		ModalNovoAnexo,
		ModalAssinaturaEletronica,
		ModalNovoDocumento,
		ModalAssinaturaProgressoLote,
		ModalSelecaoTipoAssinatura,
	},
	mixins: [assinatura, documentoMixin, convidarSignatarios, validacaoAta],
	data() {
		return {
			idAta: this.$route.params.id,
			idAditivoApostila: this.$route.params.idAditivoApostila,
			documentos: [],
			signatarios: [],
			totalItens: 0,
			exibirModalSignatarios: false,
			exibirModalConvidarSignatarios: false,
			exibirModalConfirmacao: false,
			tituloDocumento: '',
			tituloModal: '',
			subtituloConfirmacaoModal: '',
			mensagemConfirmacaoModal: '',
			totalPaginas: 0,
			paginacao: paginacaoListagem(['id']),
			idAssociacao: null,
			confirmarAcaoModal: () => {},
			fecharAcaoModal: () => {},
			exibirModalAdicionarDocumento: false,
			exibirModalAdicionarAnexo: false,
			menuAcoesItens: this.getMenuAcoesItens(),
			menuAcoesEmMassa: this.getMenuAcoesEmMassa(),
			tipoModeloDocumento: [tipoModeloDocumento.ATA_REGISTRO_PRECO.value, tipoModeloDocumento.OUTROS.value],
			// eslint-disable-next-line vue/no-unused-properties
			actionsSignatarios: actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.ata.documentosAta.filtro,
			infoAta: (state) => state.ata.informacoesAta,
			atualizarListagem: (state) => state.ata.documentosAta.atualiza,
			documentosSelecionados: (state) => state.ata.documentosAta.documentosSelecionados,
			aditivoApostila: (state) => state.aditivoApostila,
			isProcessoDigitalAtivo: (state) => state.parametrosSistema.isProcessoDigitalAtivo,
		}),
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		hasItens() {
			return this.totalItens > 0
		},
		textosTemplateListagemVazia() {
			return {
				titulo: 'Você não possui documento adicionado',
				mensagem: this.aditivoApostila.isEfetivado ? '' : 'Clique no botão para começar',
			}
		},
	},
	watch: {
		atualizarListagem: {
			async handler() {
				await this.buscarDocumentos()
			},
		},
	},
	async mounted() {
		await this.buscarDocumentos()
	},
	async created() {
		await this.carregarInformacoesDaAta()
	},
	methods: {
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
			await this.montaInformacoes()
		},
		montaInformacoes() {
			this.atualizaCabecalho(this.cabecalho)
		},
		atualizaCabecalho(informacoes) {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, informacoes)
		},
		buscarSignatarios(idAssociacao) {
			return this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_SIGNATARIOS, idAssociacao)
		},
		async tratarEventoCriarTermoDesentranhamento(documento) {
			this.setMensagemLoading('Carregando o termo de desentranhamento...')
			const criarTermoDesentranhamentoInput = {
				idDocumento: documento.id,
				idAditivoApostila: this.idAditivoApostila,
			}
			const termoDesentranhamento = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO,
				criarTermoDesentranhamentoInput,
			)

			await this.$router.push({
				name: routesNames.ADITIVO_APOSTILA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					idAta: this.idAta,
					idAditivoApostila: this.idAditivoApostila,
					idTermo: termoDesentranhamento.documento.idAssociacao,
				},
			})
		},
		async tratarEventoContinuarElaboracaoTermoDesentranhamento(documento) {
			await this.$router.push({
				name: routesNames.ADITIVO_APOSTILA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					idAta: this.idAta,
					idAditivoApostila: this.idAditivoApostila,
					idTermo: documento.idReferenciaTermoDesentranhamento,
				},
			})
		},
		async buscarDocumentos() {
			this.limparDocumentosSelecionados()
			this.filtro.idAditivoApostila = { value: this.idAditivoApostila }

			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.BUSCAR_POR_FILTRO,
				this.idAta,
			)

			if (this.isProcessoDigitalAtivo) {
				await this.buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote()

				this.documentos = await this.buscarSignatariosDocumento(itens)
			} else {
				this.documentos = itens
			}

			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.filtro.idAditivoApostila.value = null
		},
		async buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote() {
			this.validarAssinaturaEmLote(await this.buscarAssinaturasNaoConcluidas())
		},
		async atualizarModalAssinaturasNaoConcluidas() {
			this.limparDocumentosAssinaturasNaoConcluidas()
			this.setMensagemLoading('Carregando documentos com assinaturas não concluídas...')
			this.assinaturasDocumentosNaoConcluidas = await this.buscarAssinaturasNaoConcluidas()
		},
		async buscarAssinaturasNaoConcluidas() {
			const { itens } = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_ASSINATURAS_NAO_CONCLUIDAS,
				this.idAta,
			)
			return itens
		},
		async salvarAnexo() {
			const documentoComAnexo = this.$store.state.campoArquivoNovo.documentoComAnexo
			documentoComAnexo.idAditivoApostila = this.idAditivoApostila

			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.ANEXOS.CRIAR, documentoComAnexo)
			await this.buscarDocumentos()
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarDocumentos()
			await this.carregarInformacoesDaAta()
		},
		async salvarDocumento(dados) {
			const documento = await this.adicionarDocumento(dados)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarDocumentos()
			await this.carregarInformacoesDaAta()
			this.redirecionarPara(documento.urlEdicao)
		},
		async adicionarDocumento(dados) {
			dados.idAditivoApostila = this.idAditivoApostila
			return await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.ADICIONAR, dados)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async validarSeDocumentoFoiAssinadoNoProcessoDigital(documento) {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarDigitalmenteDocumento(documento) {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumento(documento) {
			this.setMensagemLoading('Assinando documento eletronicamente...')
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumentoEmLote(idsDocumentosAssinatura) {
			this.setMensagemLoading('Assinando documentos eletronicamente...')
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE_LOTE,
				new AssinarEletronicamenteDocAtaLoteInput(this.idAta, idsDocumentosAssinatura),
			)
		},
		abrirModalJuntar() {
			if (this.documentosSelecionados.length === 0) {
				this.mostrarNotificacaoErro('Não possui itens para juntar!')
			} else {
				const mensagemJuntarItens =
					'Clique no botão de Confirmar se deseja que os documentos/anexos sejam enviados para o processo digital.'
				const subtituloJuntarItens = 'Gostaria de juntar os documentos ao processo digital?'
				const tituloModalJuntarItens = 'Juntar'

				this.confirmarAcaoModal = this.juntarItensEmMassa
				this.fecharAcaoModal = this.fecharModalJuntar

				this.tituloModal = tituloModalJuntarItens
				this.mensagemConfirmacaoModal = mensagemJuntarItens
				this.subtituloConfirmacaoModal = subtituloJuntarItens

				this.exibirModalConfirmacao = true
			}
		},
		fecharModalJuntar() {
			this.subtituloConfirmacaoModal = ''
			this.exibirModalConfirmacao = false
			this.itemSelecionado = null
		},
		async juntarItensEmMassa() {
			const payload = {
				id: this.infoAta.id,
				idsDocumentos: this.documentosSelecionados.map((item) => item.id),
			}

			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS, payload)
			await this.buscarDocumentos()
			this.fecharModalJuntar()
			this.mostrarNotificacaoSucesso('Documentos foram juntados ao processo digital.')
		},
		limparDocumentosSelecionados() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM)
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.RESETAR_PAGINA_LISTAGEM)
			this.limparDocumentosSelecionados()
		},
		abrirOuFecharModalAdicionarDocumento() {
			this.exibirModalAdicionarDocumento = !this.exibirModalAdicionarDocumento
		},
		abrirOuFecharModalNovoAnexo() {
			this.exibirModalAdicionarAnexo = !this.exibirModalAdicionarAnexo
		},
		setPaginacaoListagem(paginacao) {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.buscarDocumentos()
		},
		getMenuAcoesItens() {
			return {
				nome: 'Adicionar',
				itens: [
					{
						titulo: 'Documento',
						icone: {
							nome: 'description',
						},
						evento: 'adicionar-documento',
					},
					{
						titulo: 'Anexo',
						icone: {
							nome: 'attach_file',
						},
						evento: 'adicionar-anexo',
					},
				],
			}
		},
		getMenuAcoesEmMassa() {
			const objBotoes = {
				nome: 'MAIS AÇÕES',
				itens: [
					{
						titulo: 'Assinar',
						icone: {
							nome: 'mdi-draw-pen',
						},
						evento: 'assinar-documentos',
						authorization: permissoes.ataAssinaturaEletronicaCriar,
					},
				],
			}

			if (this.$store.state.ata.informacoesAta.situacao === situacoes.ATA.EFETIVADO.value) {
				objBotoes.itens.push({
					titulo: 'Juntar',
					icone: {
						nome: 'mdi-file-replace',
					},
					evento: 'juntar-documentos',
					authorization: permissoes.ataProcessoDigitalJuntarLote,
				})
			}

			return objBotoes
		},
	},
}
</script>
